// extracted by mini-css-extract-plugin
export default {"dialogFooter":"footer_dialogFooter__U4JRd","pageFooter":"footer_pageFooter__+ucYn","centered":"footer_centered__HDa77"};